<div class="prepare-all-list">
  <app-lessons-list [showHeader]="true"></app-lessons-list>
</div>